var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgObliqueDownArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "diagonal-arrow-right-up"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5.49999 14.5977C5.49999 14.8187 5.58779 15.0306 5.74407 15.1869C5.90035 15.3432 6.11231 15.431 6.33332 15.431L13 15.4727C13.221 15.4727 13.433 15.3849 13.5892 15.2286C13.7455 15.0723 13.8333 14.8603 13.8333 14.6393C13.8333 14.4183 13.7455 14.2063 13.5892 14.0501C13.433 13.8938 13.221 13.806 13 13.806L8.36666 13.806L15.2583 6.89766C15.3364 6.82019 15.3984 6.72802 15.4407 6.62647C15.483 6.52492 15.5048 6.416 15.5048 6.30599C15.5048 6.19598 15.483 6.08706 15.4407 5.98551C15.3984 5.88396 15.3364 5.79179 15.2583 5.71432C15.1809 5.63622 15.0887 5.57422 14.9871 5.53191C14.8856 5.4896 14.7767 5.46782 14.6667 5.46782C14.5566 5.46782 14.4477 5.4896 14.3462 5.53191C14.2446 5.57422 14.1525 5.63622 14.075 5.71432L7.16666 12.6227L7.16666 7.97266C7.16666 7.75164 7.07886 7.53968 6.92258 7.3834C6.7663 7.22712 6.55434 7.13932 6.33333 7.13932C6.11231 7.13932 5.90035 7.22712 5.74407 7.3834C5.58779 7.53968 5.49999 7.75164 5.49999 7.97265L5.49999 14.5977Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgObliqueDownArrow);
export default __webpack_public_path__ + "static/media/oblique_down_arrow.cc913daadd22718864bb172486ae0df8.svg";
export { ForwardRef as ReactComponent };